import App from "@/app";
import { createGlobalApi } from "@/modules/irohana-components/utils/api";
import reportWebVitals from "@/reportWebVitals";
import { globalBaseURL, onError } from "@/utils/api";
import * as Sentry from "@sentry/react";
import Cookies from "js-cookie";
import ReactDOM from "react-dom/client";

// irohana-components の globalApi は host アプリが初期化する必要がある(未初期化だと undefined)。
// アプリ側の globalApi と同じ baseURL / エラーハンドラ / トークンを渡す。
createGlobalApi({
  apiHost: globalBaseURL,
  onError,
  getAuthToken: () => Cookies.get("match_token"),
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 0.5, //  Capture 50% of the transactions

  autoSessionTracking: true, // Automatically track sessions

  // Session Replay
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: "irohana@1.0.0",
});

root.render(<App />);

reportWebVitals();
